import { ChartProvider } from './context';
import ChartToolbar from './components/chartToolbar';
import FieldSidebar from './components/fieldSidebar';
import ChartHeading from './components/chartHeading';
import ChartRenderer from './components/chartRenderer';
import ChartLegend from './components/chartLegend';
import DownloadChartModal from './components/downloadChartModal';

export const Chart = {
    Provider: ChartProvider,
    Toolbar: ChartToolbar,
    FieldSidebar: FieldSidebar,
    Heading: ChartHeading,
    Renderer: ChartRenderer,
    Legend: ChartLegend,
    DownloadModal: DownloadChartModal,
};

export type { ChartDataSource, ChartDescriptor, ChartReport, ConsolidatedMode } from './types';
